export default __webpack_public_path__ + "static/media/Asset-80.e610667e.png";